import { createContext } from "react";

// what we'll keep in this context
// - isOnStudentSide: useful for rendering the teacher/student sidebar
export const MainNavContext = createContext(null);
